import React from 'react';
import { createRoot } from 'react-dom/client';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { DndProvider } from 'react-dnd';
import Pomodoro from './containers/Pomodoro';

const root = createRoot(document.getElementById('root'));
root.render(
  <DndProvider backend={HTML5Backend}>
    <Pomodoro />
  </DndProvider>
);
